

















import { Component, Vue } from "vue-property-decorator";
import CampaignsReportSummary from "./CampaignsReport/CampaignsReportSummary.vue";
import BehaviorReportSummary from "./BehaviorReport/BehaviorReportSummary.vue";
import ClientCampaignsPerformanceSummary from "./ClientCampaignsPerformance/ClientCampaignsPerformanceSummary.vue";
import MissingBanners from "./MissingBanners/MissingBanners.vue";
import SellersCampaigns from "./SellersCampaigns/SellersCampaigns.vue";

@Component
export default class Reports extends Vue {
  reportList = [
    {
      component: MissingBanners,
      props: { summary: true },
    },
    {
      component: SellersCampaigns,
      props: { summary: true },
    },
    {
      component: ClientCampaignsPerformanceSummary,
      props: {},
    },
    {
      component: BehaviorReportSummary,
      props: {},
    },
    {
      component: CampaignsReportSummary,
      props: {},
    },
  ];
}
